module.exports = __webpack_public_path__ + "static/media/img.979e1b7a.jpg";